<template>
  <div class="add_discussion">
    <el-dialog
      title="管理讨论组"
      :visible.sync="openDialog"
      width="50%"
      class="dialog_title"
      @close="closeDialog"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="110px"
        size="medium"
      >
        <el-form-item label="讨论组名称：" prop="title">
          <el-input
            v-model="form.title"
            placeholder="请输入讨论组名称"
            clearable
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item>
        <el-form-item label="讨论主题：" prop="theme">
          <el-input
            v-model="form.theme"
            placeholder="请输入讨论主题"
            clearable
            :style="{ width: '100%' }"
          ></el-input>
        </el-form-item>
        <el-form-item label="发起人：" prop="truename">
          <el-input
            v-model="form.truename"
            placeholder="请输入发起人"
            disabled
            :style="{ width: '100%' }"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="成员管理：" prop="user_id">
          <el-select
            v-model="form.user_id"
            placeholder="请选择成员管理"
            multiple
            clearable
            filterable
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="(item, index) in user_idOptions"
              :key="index"
              :label="item.truename"
              :value="item.user_id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormManager" size="small"
          >提 交</el-button
        >
        <el-button @click="cancel" size="small">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ClassMemberList, ManagerSelfDiscuss,ManagerSelfDiscussEdit } from "@/api/tearcher";
export default {
  data() {
    return {
      openDialog: false,
      user_idOptions: [],
      form: {},
      rules: {
        title: [
          { required: true, message: "请输入讨论组名称", trigger: "blur" },
        ],
        theme: [{ required: true, message: "请输入讨论主题", trigger: "blur" }],
        //   truename: [{ required: true, message: '请输入发起人', trigger: 'blur' }],
        user_id: [
          {
            required: true,
            type: "array",
            message: "请至少选择一个用户",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    // 取消按钮
    cancel() {
      this.openDialog = false;
    },
    // 提交
    submitFormManager: function () {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.id != undefined) {
            let formPost = { ...this.form };
            formPost.discuss_id = formPost.id;

            ManagerSelfDiscussEdit(formPost).then((response) => {
              if (response.error_code === 201) {
                this.messageTips("修改成功","success");
                this.openDialog = false;
                this.$emit('requestCommonFn')
              }
            });
          } else {
          }
        }
      });
    },
    closeDialog() {},
    // 操作dialog
    operationDialog(row, class_id) {
      this.openDialog = true;
      // 根据班级id获取班级人员信息 包括老师
      ClassMemberList({ class_id: class_id }).then((res) => {
        this.user_idOptions = res.data;
      });
      // 管理讨论组回显内容
      ManagerSelfDiscuss({id:row.id})
        .then((res) => {
          this.form = res.data;
        })
        .catch((rs) => {
         
        }); 
    },
    // 取消按钮
    cancel() {
      this.openDialog = false;
    },
  },
};
</script>
 
<style lang = "less" scoped>
.add_discussion {
  .el-dialog {
  }
  /deep/ .el-form {
    .el-input {
      width: 500px !important;
    }
    .el-input__inner {
      width: 500px;
    }
  }
}
</style>